module.exports = __webpack_public_path__ + "img/IMG_20200726_142827.76bcc75a.jpg";